import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "0%",
        x2: "100%",
        y1: "50%",
        y2: "50%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#1267EF"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#0BEADE"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "nonzero",
      d: "M12.64 0H1.36C.61 0 0 .576 0 1.287v7.396c.026.693.627 1.242 1.361 1.242h1.923l1.71 2.336.022.028a.606.606 0 0 0 .883.036l2.384-2.4h4.356C13.39 9.925 14 9.35 14 8.64V1.287C14 .576 13.39 0 12.64 0m-2.134 7.188H5.568a.518.518 0 0 1-.03-1.033h4.938a.518.518 0 0 1 .03 1.033m0-3.067-.033.001h-6.95a.518.518 0 0 1-.03-1.033l.034-.001h6.949a.518.518 0 0 1 .03 1.033",
      transform: "translate(0 .75)"
    }, null, -1)
  ])))
}
export default { render: render }